import '@/index.css';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import App from './app';
import { initSentry } from './sentry';

// Initialize Sentry before app render
initSentry();

const container = document.getElementById('root');

if (!container) {
  throw new Error("React root element doesn't exist!");
}

const root = createRoot(container);
root.render(<App />);
